import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vert-menu',
  templateUrl: './vert-menu.component.html',
  styleUrls: ['./vert-menu.component.css']
})
export class VertMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
